<template>
  <div>
    <treeselect v-model="value" :flat="true" :multiple="true" :options="options" :disable-branch-nodes="true" />
  </div>
</template>

<script>
import axios from "axios";
import config from "../../../helpers/config"

import Treeselect from "@riophae/vue-treeselect";
// import the styles
import "@riophae/vue-treeselect/dist/vue-treeselect.css";

export default {
  props: {
    onClick: Function,
    threat_id: {
      default: () => [],
      type: Array
    }
  },
  mounted() {
    this.getObjetives();
    this.value = this.threat_id;
  },
  data() {
    return {
      value: [],
      options: [],
      value: null
      // define options
    };
  },
  watch: {
    value: function(newVal, oldVal) {
      this.onClick(newVal);
    }
  },
  methods: {
    getObjetives() {
      const that = this;
      function getAdaptLevels() {
        return axios.get(`${config.urlApi}/threats`);
      }

      function getSAdaptSubLevels() {
        return axios.get(`${config.urlApi}/threatSubTypes`);
      }

      axios.all([getAdaptLevels(), getSAdaptSubLevels()]).then(
        axios.spread(function(levels, subLevels) {
          //////console.log(levels.data, subLevels.data);
          const options = levels.data.map(({ id, type }) => {
            return {
              id: id,
              label: type,
              children: subLevels.data
                .filter(item => item.idThreatType === id)
                .map(({ id, subType }) => {
                  return { id: `c:${id}`, label: subType };
                })
            };
          });
          //////console.log(options);
          that.options = options;
        })
      );
    }
  },
  components: {
    Treeselect
  }
};
</script>
